import { uniqueId } from 'lodash-es';
import React from 'react';
import { TOpenModal } from '../../../../JSApi/types';
import EventEmitter from '../../../../utils/util/eventEmitter';
import ApiaFunctionsModalChild from './ApiaFunctionsModalChild';

export type TApiaFunctionsModalProps = TOpenModal & { id: string };

export const apiaFunctionsModalEmitter =
  new (class ApiaFunctionsModalEmitter extends EventEmitter<{
    close: TApiaFunctionsModalProps;
    open: TOpenModal;
  }> {})();

const ApiaFunctionsModals = () => {
  const [modals, setModals] = React.useState<TApiaFunctionsModalProps[]>([]);

  React.useEffect(() => {
    const unsuscribe1 = apiaFunctionsModalEmitter.on('open', (ev) =>
      setModals((current) => [...current, { ...ev, id: uniqueId() }]),
    );
    const unsuscribe2 = apiaFunctionsModalEmitter.on('close', (ev) => {
      setModals((current) => current.filter((search) => search.id !== ev.id));
      ev.onClose?.();
    });

    return () => {
      unsuscribe1();
      unsuscribe2();
    };
  }, []);

  return (
    <>
      {modals.map((current) => (
        <ApiaFunctionsModalChild modal={current} key={current.id} />
      ))}
    </>
  );
};

export default ApiaFunctionsModals;
